import { Insta } from "../../src/components/insta/InstaClass";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { chris } from "../characters/Chris";
import { empty } from "../characters/empty";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doTransition, getInstaImage } from "../helpers/helpers";
import { images } from "./images";
import { AfterClubEndDay } from "./V4";
import SoundClass from "../../src/shell/Sound";
import { music } from "./sounds";

export const AfterClubVanessaLeftAloneGoFast = async (): Promise<any> => {
    doTransition(images.v4.VanessaAfterPartyJoeOutsideStreet);
    mc.think(`Almost there!`);
    if (mc.properties.annLateHate || Question.globalAnswers.v4ToldAnnGoingToHelpVanessa) {
        // SoundClass.startMusic(music.V4VanessaAfterParty, { shouldPlay: true, loop: true });
        ImageClass.setImage(images.v4.VanessaAfterParty2);
        mc.think(`They are still doing bodyshots.`);
        vanessa.talk(`HAAHAA!`);
        mc.think(`Vanessa sounds excited.`);
        chris.talk(`Who is next?`);
        ImageClass.setImage(images.v4.VanessaAfterParty3);
        vanessa.talk(`DOOFUS you are back!`);
        if (Question.globalAnswers.v4StayedWithVanessaAlleyBJ) {

            vanessa.talk(`Did you go to masturbate after my little show? Hahaha.`);
        }
        ImageClass.setImage(images.v4.VanessaAfterParty4);
        chris.talk(`${mc.name}, do you want a drink?`);
        chris.talk(`It's on me. Or on Vanessa depending on how you look at it, haha.`);
        ImageClass.setImage(images.v4.VanessaAfterParty5);
        await mc.setQuestion(new Question({ text: `Vanessa looks really drunk.`, options: { think: true }, key: `v4VanessaDrunkDidBodyShot` })
            .option({ title: `Help her get home`, key: false })
            .option({ title: `Do a body shot`, key: true }));


        if (Question.globalAnswers.v4VanessaDrunkDidBodyShot) {



            mc.talk(`You know what?`);
            mc.talk(`I'll have that shot you suggested.`);
            chris.talk(`Now you are talking!`);
            ImageClass.setImage(images.v4.VanessaAfterParty6);
            chris.talk(`That's the best way to drink shots.`);
            mc.talk(`Damn right.`);
            ImageClass.setImage(images.v4.VanessaAfterParty7);
            vanessa.talk(`Hahaa!`);
            ImageClass.setImage(images.v4.VanessaAfterParty7, { shake: true });
            empty.think(`SLAM!`);
            mc.think(`What's that noise?`);
            ImageClass.setImage(images.v4.VanessaAfterParty8);
            joe.talk(`WHAT THE FUCK ${mc.name.toLocaleUpperCase()}?!`);
            mc.think(`Shit, I just can't win.`);
            ImageClass.setImage(images.v4.VanessaAfterParty9);
            vanessa.talk(`Honeyyy!`);
            joe.talk(`Get the fuck away from her.`);
            vanessa.talk(`My knight in shining tank!`);
            vanessa.talk(`I knew you cared about me!`);
            ImageClass.setImage(images.v4.VanessaAfterParty10);
            joe.talk(`What the fuck Vanessa? What are you doing?`);
            vanessa.talk(`Nothing.`);
            vanessa.talk(`I am just laying. My legs hurt.`);
            joe.talk(`Get up, it's time to go home.`);
            ImageClass.setImage(images.v4.VanessaAfterParty11);
            joe.talk(`${mc.name}, I don't know what happened to you but you became an asshole.`);
            joe.talk(`I'm sorry I was your friend.`);
            vanessa.talk(`Don't listen to himmm, he didn't mean it.`);
            ImageClass.setImage(images.v4.VanessaAfterParty10);
            joe.talk(`I meant every word.`);
            joe.talk(`Let's go.`);
            ImageClass.setImage(images.v4.VanessaAfterParty10);
            return jump(AfterClubVanessaLeftAloneBodyShotContinue, "AfterClubVanessaLeftAloneBodyShotContinue");
        } else {
            ImageClass.setImage(images.v4.VanessaAfterParty5);
            mc.talk(`Vanessa, are you ok?`);
            vanessa.talk(`Of course, I'm fine.`);
            mc.talk(`You are drunk. I should take you home.`);
            vanessa.talk(`But whyyy??`);
            mc.talk(`Come on, let's go.`);
            ImageClass.setImage(images.v4.VanessaAfterParty12, { transition: true });
            // SoundClass.stopMusic(music.V4VanessaAfterParty);
            mc.talk(`Vanessa?`);
            mc.think(`The alcohol hit her hard once she stood.\nGood thing I got here fast.`);
            vanessa.talk(`Ah?`);
            mc.talk(`Just checking to see if you are still awake.`);
            vanessa.talk(`Bed.`);
            mc.talk(`We are going there, just don't throw up on me.`);
            ImageClass.setImage(images.v4.VanessaAfterPartyHome1, { transition: true });
            mc.talk(`Here we are.`);
            vanessa.talk(`My room.`);
            mc.talk(`Yeah...`);
            ImageClass.setImage(images.v4.VanessaAfterPartyHome2);
            vanessa.talk(`Thank you ${mc.name}.`);
            mc.think(`It was worth it just so she would stop calling me doofus.`);
            mc.talk(`How are you feeling?`);
            vanessa.talk(`Heels.`);
            mc.talk(`Huh?`);
            vanessa.talk(`Heels.`);
            mc.talk(`Do you want me to remove them?`);
            vanessa.talk(`Yes.`);
            ImageClass.setImage(images.v4.VanessaAfterPartyHome3);
            mc.talk(`One leg...`);
            ImageClass.setImage(images.v4.VanessaAfterPartyHome4, { wait: true });
            ImageClass.setImage(images.v4.VanessaAfterPartyHome5);
            mc.talk(`And the second.`);
            ImageClass.setImage(images.v4.VanessaAfterPartyHome6, { wait: true });
            return jump(AfterClubVanessaLeftAlone2, "AfterClubVanessaLeftAlone2");
        }
    }
    return jump(AfterClubVanessaLeftAloneWaitAbit, "AfterClubVanessaLeftAloneWaitAbit");
};

export const AfterClubVanessaLeftAloneWaitAbit = async (): Promise<any> => {
    ImageClass.setImage(images.v4.VanessaAfterPartyJoeOutsideStreet, { transition: true });
    mc.think(`It took some time for Ann to fall asleep I hope I am not late.`);
    ImageClass.setImage(images.v4.VanessaAfterPartyJoeOutside, { transition: true });
    mc.think(`Shit.`);
    joe.talk(`${mc.name}? What are you doing here?`);
    if (mc.properties.liar >= 5) {

        mc.talk(`I just came for a drink.`);
        mc.think(`Lying helped me so far.`);
        joe.talk(`Since when you are going out alone?`);
        mc.talk(`Just recently.`);
        joe.talk(`I don't buy it.`);
        mc.talk(`What happened to Vanessa?`);
        joe.talk(`It's none of your business.`);
    } else {

        mc.talk(`I got a text that Vanessa might need my help.`);
        joe.talk(`Why would YOU get a text?`);
        mc.talk(`I don't know, I just did.`);
        mc.talk(`How did you know to come here?`);
        joe.talk(`I don't need to explain anything to you.`);
    }
    ImageClass.setImage(images.v4.VanessaAfterPartyJoeOutside_2);
    mc.think(`They left.`);
    mc.think(`I don't think he got Vanessa's phone from Chris.`);
    return jump(AfterClubVanessaLeftAloneBodyShotContinue, "AfterClubVanessaLeftAloneBodyShotContinue");
};


export const AfterClubVanessaLeftAlone2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.VanessaAfterPartyHome7);

    await mc.setQuestion(new Question({ text: `She fell asleep already.`, options: { think: true }, key: `v4VanessaDrunkLiftedHerDress` })
        .option({ title: `Go home`, key: false })
        .option({ title: `Lift her dress`, key: true }));


    if (Question.globalAnswers.v4VanessaDrunkLiftedHerDress) {
        ImageClass.setImage(images.v4.VanessaAfterPartyHome8);
        mc.think(`A sneak peek wouldn't hurt.`);
        ImageClass.setImage(images.v4.VanessaAfterPartyHome9);
        mc.think(`It's not something that I haven't seen already.`);
        await mc.setQuestion(new Question({ text: `Damn, she is so hot.`, options: { think: true }, key: `v4VanessaDrunkExposedBreasts` })
            .option({ title: `Expose her breasts`, key: true })
            .option({ title: `Stop`, key: false }));


        if (Question.globalAnswers.v4VanessaDrunkExposedBreasts) {
            ImageClass.setImage(images.v4.VanessaAfterPartyHome10);
            if (mc.properties.v1MCSawVanessasBoobsAss === undefined && Question.globalAnswers.todMCDareVanessa === "showPanties" && Question.globalAnswers.v1WentToTheBarWith === "ann") {

                mc.think(`I've been dying to see them.`);
                mc.think(`Amazing round breast.`);
            } else {

                mc.think(`I've seen her breasts before, so no harm was done.`);
            }
            mc.think(`The thought of continuing is running through my mind, but I'm not a molester.`);
            mc.think(`I better get home now.`);
        } else {
            mc.think(`Nah... I'm not gonna do it... I've seen enough.`);
            return jump(AfterClubVanessaLeftAloneHome, "AfterClubVanessaLeftAloneHome");
        }
    } else {
        return jump(AfterClubVanessaLeftAloneHome, "AfterClubVanessaLeftAloneHome");
    }


    return jump(AfterClubVanessaLeftAloneHome, "AfterClubVanessaLeftAloneHome");
};

export const AfterClubVanessaLeftAloneBodyShotContinue2 = async (): Promise<any> => {

    if (getInstaImage(Insta.instaProfiles?.[alex.name], `${alex.name}18`)?.mcSeen) {
        ImageClass.setImage(images.v4.VanessaAfterPartyChris2);
        await mc.setQuestion(new Question({ text: `Blonde chick? Could he be talking about Alex?`, options: { think: true }, key: `v4ShowedChrisAlexsInsta` })
            .option({ title: `Ask him to describe her`, key: false })
            .option({ title: `Show him her Insta`, key: true }));

        if (Question.globalAnswers.v4ShowedChrisAlexsInsta) {
            ImageClass.setImage(images.v4.VanessaAfterPartyChris1_2);
            mc.talk(`Take a look, is that her?`);
            ImageClass.setImage(images.v4.VanessaAfterPartyChris3);
            chris.talk(`Let me see.`);
            chris.talk(`DAYUMMMMM!`);
            if (Question.globalAnswers.v4NoJoeyWasMeanToChris) {
                mc.talk(`Well, is that her?`);
                ImageClass.setImage(images.v4.VanessaAfterPartyChris4);
                chris.talk(`Maybe.`);
                mc.talk(`What do you mean by maybe?`);
                chris.talk(`That's none of your business.`);
                mc.talk(`What the fuck?`);
                chris.talk(`Should I refresh your memory?`);
                chris.talk(`That's what you were telling me not long ago.`);
                mc.think(`I guess I deserve that after the way I spoke to him earlier.`);
            } else {
                ImageClass.setImage(images.v4.VanessaAfterPartyChris4);
                chris.talk(`That's her alright.`);
                ImageClass.setImage(images.v4.VanessaAfterPartyChris3);
                chris.talk(`So her name is Alex. Good to know.`);
                if (mc.properties.agreeToChrisProposal) {
                    chris.talk(`I'm glad you decided to share your girls, I'm dying to fuck her already.`);
                    mc.talk(`Hold your horses, you need to wait for my approval.`);
                    ImageClass.setImage(images.v4.VanessaAfterPartyChris4);
                    chris.talk(`Don't worry, I'm not going to get in your way.`);
                    mc.talk(`Great.`);

                } else if (mc.properties.agreeToChrisProposal === false) {
                    ImageClass.setImage(images.v4.VanessaAfterPartyChris4);
                    chris.talk(`Now I understand why you didn't want to share you girls.`);
                    chris.talk(`That's too bad.`);
                    chris.talk(`I hope you will change your mind and let me have a piece of that ass.`);

                } else {
                    mc.talk(`Hold your horses, she is mine.`);
                    ImageClass.setImage(images.v4.VanessaAfterPartyChris4);
                    chris.talk(`Don't worry, I'm not going to get in your way.`);
                    mc.talk(`Great.`);

                }
            }


            ImageClass.setImage(images.v4.VanessaAfterPartyChris5);
            chris.talk(`Here is your phone.`);
            ImageClass.setImage(images.v4.VanessaAfterPartyChris2);
            mc.talk(`Thanks.`);
            mc.talk(`And Vanessa's?`);
        } else {
            mc.talk(`Can you describe her?`);
            chris.talk(`Why? Do you know her?`);
            mc.talk(`I might.`);
            if (Question.globalAnswers.v4NoJoeyWasMeanToChris) {
                chris.talk(`That's none of your business.`);
                chris.talk(`I would tell you if I didn't a have bar to tend.`);
                mc.think(`I guess I deserve that after the way I was talking to him earlier.`);
            } else {
                chris.talk(`Nice tits, beautiful face, thin, shoulders length blonde hair.`);
                mc.talk(`Do you remember what she was wearing?`);
                chris.talk(`I usually bad at remembering things, but I sure remember that one.`);
                chris.talk(`She had a pink and blue dress if you can call what she was wearing a dress.`);
                chris.talk(`The top part was open up to her belly button, her tits were almost out.`);
                mc.think(`That must be her!`);
                mc.talk(`What were you talking about?`);
                chris.talk(`What's with all the questions?`);
                mc.talk(`I might know her.`);
                chris.talk(`So, why don't you ask her?`);
                mc.talk(`I don't know, know her. I just saw her a few times.`);
                chris.talk(`Ok...`);
                chris.talk(`We weren't really talking, she said that "the naked girl on the bar dropped it on the floor".`);
                chris.talk(`I tried to talk to her but she left in a hurry.`);
                mc.talk(`Alright, thanks Chris.`);
                chris.talk(`Anytime.`);
            }

        }

        ImageClass.setImage(images.v4.VanessaAfterPartyChris6);
        chris.talk(`Here's Vanessa's phone.`);
    } else {

        ImageClass.setImage(images.v4.VanessaAfterPartyChris6);
        chris.talk(`There you go.`);
    }


    mc.talk(`Thanks.`);
    ImageClass.setImage(images.v4.VanessaAfterPartyChris2);
    chris.talk(`Anything else?`);
    if (mc.properties.v4SawAnnBJChrisInCar) {
        mc.talk(`Is Ann ok?`);
        chris.talk(`Sure, why do you ask?`);
        mc.talk(`Just making sure she got home safe.`);
        if (mc.properties.agreeToChrisProposal) {
            chris.talk(`Haha, trust me she did, right after blowing me.`);
            chris.talk(`Can you believe it? Haha.`);
            mc.talk(`To be honest I can't...`);
            chris.talk(`I was skeptical but I had to try.`);

            mc.talk(`But I thought we had an agreement.`);
            chris.talk(`We still do, you gave her up so I jumped on the opportunity.`);
            chris.talk(`If I saw that you were interested I wouldn't have done that.`);
            mc.talk(`Alright.`);
            mc.talk(`I'll get going now.`);
            chris.talk(`Bye bro.`);
        } else {

            chris.talk(`She did.`);
        }
    } else {

        mc.talk(`That's all, thanks.`);
    }

    if (Question.globalAnswers.v4VanessaDrunkDidBodyShot === false) {

        return jump(AfterClubEndDay, "AfterClubEndDay");
    }

    mc.think(`Nothing else to do here.\nI better get home.`);

    return jump(AfterClubVanessaLeftAloneBodyShotJoeVanessaOutside, "AfterClubVanessaLeftAloneBodyShotJoeVanessaOutside");

};
export const AfterClubVanessaLeftAloneBodyShotJoeVanessaOutside = async (): Promise<any> => {
    ImageClass.setImage(images.v4.VanessaAfterPartyJoeVanessaOut1, { transition: true });
    mc.think(`Wait.\nIs that Vanessa and Joe?`);
    mc.think(`What are they still doing here?`);
    mc.think(`I'll try to get closer so I can hear what they are talking about.`);
    ImageClass.setImage(images.v4.VanessaAfterPartyJoeVanessaOut2);
    joe.talk(`I still don't get you.`);
    vanessa.talk(`Ahh... I told youuu...`);
    vanessa.talk(`I wasss afraid of losing youuu.`);
    joe.talk(`So you are stripping while guys can feel you up?`);
    vanessa.talk(`You didn't... want to talk to me... and youuu are here now, sooo it worked.`);
    joe.talk(`I was already yours before you decided to suck ${mc.name}'s cock.`);
    vanessa.talk(`I'm sorryyyy.`);
    mc.think(`I don't know if that's the alcohol, but she just apologized without putting the blame on me.`);
    joe.talk(`It will be hard for me to put that behind me.`);
    vanessa.talk(`Honeyyy...`);
    joe.talk(`Are you ok to walk again?`);
    vanessa.talk(`Yeah.`);
    mc.think(`I'll get out of here before they see me.`);
    if (mc.properties.annStatus === "gf") {

        doTransition(images.v4.AfterBarAnnRoom31);
        mc.think(`Good, Ann didn't wake up.`);
    } else {

    }

    return jump(AfterClubEndDay, "AfterClubEndDay");
};

export const AfterClubVanessaLeftAloneHome = async (): Promise<any> => {
    vanessa.talk(`Phone.`);
    mc.talk(`Huh?`);
    vanessa.talk(`Phone.`);
    mc.think(`Oh right, shit, I forgot to get Vanessa's phone from Chris.`);
    mc.think(`I feel like I am playing a stupid quest game.`);
    mc.think(`Back to the bar it is.`);

    return jump(AfterClubVanessaLeftAloneBodyShotContinue, "AfterClubVanessaLeftAloneBodyShotContinue");
};
export const AfterClubVanessaLeftAloneBodyShotContinue = async (): Promise<any> => {
    if (Question.globalAnswers.v4VanessaDrunkDidBodyShot === false) {

        ImageClass.setImage(images.v4.VanessaAfterPartyJoeOutsideStreet, { transition: true });
        mc.talk(`Good, the place is still open.`);
        ImageClass.setImage(images.v4.VanessaAfterPartyChris1);
        chris.talk(`What are you doing here?\nDidn't you take Vanessa home?`);
        mc.talk(`I did, but I came back for her phone she forgot it here, do you have it?`);
    } else if (Question.globalAnswers.v4VanessaDrunkDidBodyShot) {

        ImageClass.setImage(images.v4.VanessaAfterPartyChris1, { transition: true });
        chris.talk(`Damn, you got busted.`);
        mc.talk(`Yeah... I am so unlucky.`);
        chris.talk(`Well, since there aren't girls left in here anymore I'm going to call it a day and close.`);
        mc.talk(`Wait, I believe you have Vanessa's phone.`);
    } else if (Game.seenScenarios.includes(`AfterClubVanessaLeftAloneWaitAbit`)) {

        ImageClass.setImage(images.v4.VanessaAfterPartyChris1, { transition: true });
        if (mc.properties.annLateGF) {
            chris.talk(`You are back.`);
            chris.talk(`I haven't seen you since you left with Ann.`);
            mc.talk(`Yes, I came back because I heard Vanessa's might be in trouble.`);
            if (Question.globalAnswers.v4NoJoeyWasMeanToChris === false) {
                chris.talk(`Leave some girls for other guys, haha.`);
            }
            chris.talk(`Well, since there aren't girls left in here anymore I'm going to call it a day and close.`);
            mc.talk(`Wait, I believe you have Vanessa's phone.`);
        }
    } else {
        mc.talk(`Hey Chris, I believe you have Vanessa's phone`);
    }
    chris.talk(`Yes I do.`);
    chris.talk(`Some blonde chick left it here before she left.`);
    return jump(AfterClubVanessaLeftAloneBodyShotContinue2, "AfterClubVanessaLeftAloneBodyShotContinue2");
};


